module.exports = __webpack_public_path__ + "static/media/jenni-lee-lesb.f2b31cc2.jpg";